// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
/**
 * The version of the Jupyter controls widget attribute spec that this package
 * implements.
 */
export var JUPYTER_CONTROLS_VERSION = '1.5.0';
